// covered-by: frontends/carrie/src/ask-v2/rail/__tests__/AskV2RightRail.test.tsx
import { CaretDown } from "@phosphor-icons/react";
import { type ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { type AskV2RailSectionId } from "./types";

type AskV2RailSectionProps = {
  id: AskV2RailSectionId;
  title: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: ReactNode;
};

export function AskV2RailSection({
  id,
  title,
  open,
  onOpenChange,
  children,
}: AskV2RailSectionProps) {
  const { t } = useTranslation("ui");

  return (
    <section
      className="flex shrink-0 flex-col overflow-hidden rounded-xl border border-puntt-neutral-gray-5 bg-base-white"
      aria-label={title}
      data-testid={`ask-v2-rail-section-${id}`}
      data-panel-expanded={open ? "true" : "false"}
    >
      <button
        type="button"
        onClick={() => onOpenChange(!open)}
        aria-expanded={open}
        aria-label={t("askV2.rail.toggleSection", { section: title })}
        data-testid={`ask-v2-rail-toggle-${id}`}
        className="flex w-full shrink-0 items-center gap-2 bg-base-white px-4 py-3 text-left"
      >
        <h2 className="flex-1 text-[11px] font-bold uppercase tracking-wide text-puntt-neutral-gray-12">
          {title}
        </h2>
        <CaretDown
          size={14}
          aria-hidden="true"
          className={`shrink-0 text-puntt-neutral-gray-11 transition-transform ${open ? "" : "-rotate-90"}`}
        />
      </button>
      {open ? (
        <div
          className="max-h-[min(50vh,420px)] overflow-y-auto overscroll-contain border-t border-puntt-neutral-gray-5 px-4 pb-4 pt-3 [scrollbar-width:thin]"
          data-testid={`ask-v2-rail-body-${id}`}
        >
          {children}
        </div>
      ) : null}
    </section>
  );
}
